import {
    Component, OnInit, AfterViewInit, OnDestroy, NgZone,
    ViewChild, ElementRef, Renderer2, ViewEncapsulation, Inject
} from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppContentsService } from '../../../services/app-contents.service';
import { CeTooltipService } from '../../../services/ce-tooltip.service';
import { globals } from '../../../../globals';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-page-stemma',
  templateUrl: './page-stemma.component.html',
  styleUrls: ['./page-stemma.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PageStemmaComponent implements OnInit, AfterViewInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    private listeners: Array<any> = [];
    @ViewChild('mainText') mainText: ElementRef;
    @ViewChild('rightCol') rightCol: ElementRef;
    lastUpdate: string;
    title: SafeHtml;
    description: SafeHtml;
    rightColTitle: SafeHtml;
    rightColDesc: SafeHtml;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private router: Router,
        private zone: NgZone,
        private renderer: Renderer2,
        private sanitizer: DomSanitizer,
        private appContentsService: AppContentsService,
        private tooltipService: CeTooltipService
    ) {
        this.tooltipService.setRenderer(this.renderer);
    }

    ngOnInit(): void {
        this.title = globals.html_small_loading_gif;
        this.description = globals.html_small_loading_gif;
        this.rightColTitle = globals.html_small_loading_gif;
        this.rightColDesc = globals.html_small_loading_gif;

        /* Page contents */
        this.subscriptions.push(
            this.appContentsService.getPageContents('stemma')
                .subscribe(
                    page => {
                        if (page && page.name === 'stemma') {
                            this.lastUpdate = page.pubLastDate;
                            const pageDescription = page.contents.find(c => c.name === 'description');
                            const pageRightCol = page.contents.find(c => c.name === 'right-column');

                            this.title = this.sanitizer.bypassSecurityTrustHtml(page.title);
                            if (pageDescription) {
                                this.description = this.sanitizer.bypassSecurityTrustHtml(pageDescription.text);
                            }
                            if (pageRightCol) {
                                this.rightColTitle = this.sanitizer.bypassSecurityTrustHtml(pageRightCol.title);
                                this.rightColDesc = this.sanitizer.bypassSecurityTrustHtml(pageRightCol.text);
                            }
                        }
                    },
                    err => console.error(err)
                )
        );
    }

    ngAfterViewInit() {
        this.listeners.push(
            this.renderer.listen(this.mainText.nativeElement, 'click', (event) => { this.onClick(event); }),
            this.renderer.listen(this.rightCol.nativeElement, 'click', (event) => { this.onClickRightCol(event); })
        );
        this.listeners.push(
            this.renderer.listen(this.rightCol.nativeElement, 'mouseover', (event) => { this.onMouseOverRightCol(event); })
        );
    }

    private navigate(href: string) {
        if (href.indexOf('http') === 0) {
            this.document.location.href = href;
        } else {
            this.zone.run(() => this.router.navigate([href]));
        }
    }

    onClick(event) {
        event.stopPropagation();
        event.preventDefault();
        const node = event.target;

        if (node.nodeName === 'A') {
            const href = node.getAttribute('href');

            if (this.tooltipService.isReferenceLink(href)) {
                /* Show tooltip */
                if (this.tooltipService.showReferenceTooltip(node, href) === false) {
                    this.navigate(href);
                }
            }
        }

        /* Close reference button*/
        if (node.nodeName === 'I' && node.className.indexOf('rtt_close') !== -1) {
            this.tooltipService.removeReferenceTooltip();
        }
    }

    onClickRightCol(event) {
        event.stopPropagation();
        event.preventDefault();

        if (event.target.nodeName === 'A') {
            this.navigate(event.target.getAttribute('data-href'));
        }
    }

    onMouseOverRightCol(event) {
        if (event.target.nodeName === 'A') {
            event.target.style.cursor = 'pointer';
        }
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
        for (const listener of this.listeners) {
            if (listener) {
                listener();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-stemma/page-stemma.component.ts